export const PROGRESS_START = "PROGRESS_START";
export const PROGRESS_FINISH = "PROGRESS_FINISH";
export const PROGRESS_CLOSE = "PROGRESS_CLOSE";
export const PROGRESS_CLEAR = "PROGRESS_CLEAR";
